import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, BookOpen, Users, Award, ArrowRight, CheckCircle } from 'lucide-react';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4">
              <img 
                src="/images/Logos/tac-logo.png" 
                alt="Academic City Logo" 
                className="h-12 w-auto"
              />
            </div>
            <div className="flex items-center space-x-4">
              <Link
                to="/login"
                className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors shadow-md hover:shadow-lg"
              >
                Login
              </Link>
              {/* <Link
                to="/register"
                className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Get Started
              </Link> */}
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-teal-50 to-teal-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              Welcome to{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-teal-700">
                Academic City
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Join our prestigious institution and give your child the foundation for a successful future. 
              Experience world-class education with a focus on holistic development.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* <Link
                to="/register"
                className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg text-lg font-medium transition-colors flex items-center justify-center"
              >
                Start Application
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link> */}
              <Link
                to="/login/parent"
                className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg text-lg font-medium transition-colors shadow-lg hover:shadow-xl flex items-center justify-center"
              >
                Parent Login
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose Academic City?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              We provide a comprehensive educational experience that prepares students for the challenges of tomorrow.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="bg-teal-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <GraduationCap className="h-8 w-8 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Academic Excellence</h3>
              <p className="text-gray-600">
                CBSE curriculum with focus on critical thinking and problem-solving skills.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="bg-teal-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <BookOpen className="h-8 w-8 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Holistic Development</h3>
              <p className="text-gray-600">
                Sports, arts, and leadership programs for complete personality development.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="bg-teal-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Users className="h-8 w-8 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Expert Faculty</h3>
              <p className="text-gray-600">
                Experienced teachers dedicated to nurturing young minds and talents.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="bg-teal-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <Award className="h-8 w-8 text-teal-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Proven Results</h3>
              <p className="text-gray-600">
                Track record of academic success and college placements.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Campuses Section */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Campuses
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Multiple locations across India, all offering the same high-quality CBSE education.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="bg-teal-100 rounded-full p-4 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                <GraduationCap className="h-10 w-10 text-teal-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Bangalore</h3>
              <p className="text-gray-600 mb-6">
                Our flagship campus in the heart of India's tech capital, offering world-class facilities and education.
              </p>
              <div className="space-y-2 text-sm text-gray-600">
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  CBSE Curriculum
                </div>
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  Modern Infrastructure
                </div>
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  Sports Facilities
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="bg-teal-100 rounded-full p-4 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                <GraduationCap className="h-10 w-10 text-teal-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Indore</h3>
              <p className="text-gray-600 mb-6">
                Located in the cleanest city of India, providing excellent academic environment and facilities.
              </p>
              <div className="space-y-2 text-sm text-gray-600">
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  CBSE Curriculum
                </div>
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  Green Campus
                </div>
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  Technology Integration
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="bg-teal-100 rounded-full p-4 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                <GraduationCap className="h-10 w-10 text-teal-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Edify Chikkabanavara</h3>
              <p className="text-gray-600 mb-6">
                Our newest campus offering innovative learning approaches and state-of-the-art facilities.
              </p>
              <div className="space-y-2 text-sm text-gray-600">
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  CBSE Curriculum
                </div>
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  Innovation Hub
                </div>
                <div className="flex items-center justify-center">
                  <CheckCircle className="h-4 w-4 text-teal-600 mr-2" />
                  Creative Learning
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Application Process Section */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Simple Application Process
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Get started with your child's admission in just a few easy steps.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-teal-600 text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mx-auto mb-4">
                1
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Basic Information</h3>
              <p className="text-gray-600 text-sm">
                Fill out the initial application form with student and parent details.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-teal-600 text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mx-auto mb-4">
                2
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Payment</h3>
              <p className="text-gray-600 text-sm">
                Pay the application fee of ₹3,072 through our secure payment gateway.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-teal-600 text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mx-auto mb-4">
                3
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Detailed Information</h3>
              <p className="text-gray-600 text-sm">
                Complete the comprehensive application with additional details and documents.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-teal-600 text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mx-auto mb-4">
                4
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Review & Submit</h3>
              <p className="text-gray-600 text-sm">
                Review your application and submit for school administration review.
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/register"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg text-lg font-medium transition-colors inline-flex items-center"
            >
              Start Your Application
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <img 
                src="/images/Logos/tac-logo.png" 
                alt="Academic City Logo" 
                className="h-12 w-auto mb-4"
              />
              <p className="text-gray-400 text-sm">
                Excellence in Education since establishment. Building future leaders through quality education.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
                <li><Link to="/login/parent" className="hover:text-white transition-colors">Parent Login</Link></li>
                <li><Link to="/register" className="hover:text-white transition-colors">Apply Now</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Campuses</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>Bangalore</li>
                <li>Indore</li>
                <li>Edify Chikkabanavara</li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>Email: admissions@theacademiccity.com</li>
                <li>Phone: 080-47092273</li>
                <li>Address: Multiple locations across India</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Academic City. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
